<div
  class="chat-attachment-message"
  [class.chat-attachment-message--outgoing]="message.direction === 'outgoing'"
  [class.chat-attachment-message--incoming]="message.direction === 'incoming'"
>
  <div class="chat-attachment-message__content">
    <div class="chat-attachment-message__files" *ngIf="files.length">
      <div
        class="file-chip"
        *ngFor="let file of files; trackBy: trackByFile"
        [class.file-chip--uploading]="file.uploadStatus === 'uploading'"
        [class.file-chip--error]="file.uploadStatus === 'error'"
      >
        <div class="file-chip__body">
          <button
            ui-kit
            buttonFunction
            class="file-chip__icon"
            iconName="clip"
            color="neutral"
            size="small"
            type="button"
            tabindex="-1"
          ></button>

          <div class="file-chip__meta">
            <div class="file-chip__name">{{ file.name }}</div>
            <div class="file-chip__size">{{ getFileSizeLabel(file.size) }}</div>
          </div>
        </div>

        <div class="file-chip__progress" *ngIf="file.uploadStatus === 'uploading'" aria-hidden="true">
          <div class="file-chip__progress-wave"></div>
        </div>
      </div>
    </div>

    <div
      class="chat-attachment-message__bubble"
      *ngIf="message.text"
      [class.chat-attachment-message__bubble--transcribing]="isTranscribing"
    >
      <div class="chat-attachment-message__activity-row" *ngIf="isTranscribing; else plainText">
        <div class="chat-attachment-message__spinner">
          <span class="chat-attachment-message__dot"></span>
          <span class="chat-attachment-message__dot"></span>
          <span class="chat-attachment-message__dot"></span>
        </div>
        <div class="chat-attachment-message__text chat-attachment-message__text--shimmer">
          {{ message.text }}
        </div>
      </div>
      <ng-template #plainText>
        <div class="chat-attachment-message__text" [innerHTML]="message.text | markdown"></div>
      </ng-template>
    </div>
  </div>
</div>
